import { Feature } from './types';

export const PRODUCT_COSTS_FEATURES: Feature[] = ['SUPPLIES_STOCK', 'INVENTORY_MANAGEMENT'];

export const hasProductCostsFeature = (features: readonly Feature[]): boolean =>
  PRODUCT_COSTS_FEATURES.some(feature => features.includes(feature));
